import React, { Component } from 'react'


export default class Url extends Component {
    async componentDidMount(){
      
    }
    truncate = str => {
        return str.length > 45 ? str.substring(0, 50) + "..." : str;
    }
    render() {
        return (
            <a href={this.props.info.remote_url} target="_blank" style={{color:"black", textDecoration:"none"}}>
            <div className="card randal shadow">
                {/* <img src={this.props.info.img} className="card-img-top" alt="..." /> */}
                <div className="card-body">
                    <h5 className="card-title">{this.props.info.name}</h5>
                    <p className="card-text" style={{fontSize:"12px", color: "#6056A0"}}>{this.truncate(this.props.info.remote_url)}</p>
                    <p className="card-text">{this.props.info.description}</p>
                </div>
            </div>
            </a>
        )
    }
}
